import { render, staticRenderFns } from "./ncDeclaration.vue?vue&type=template&id=4a0a3869"
import script from "./ncDeclaration.vue?vue&type=script&lang=js"
export * from "./ncDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0a3869')) {
      api.createRecord('4a0a3869', component.options)
    } else {
      api.reload('4a0a3869', component.options)
    }
    module.hot.accept("./ncDeclaration.vue?vue&type=template&id=4a0a3869", function () {
      api.rerender('4a0a3869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/ncDeclaration.vue"
export default component.exports